import { Link, useLocation } from 'react-router-dom';
import { ListChecks, History } from 'lucide-react';

function OnuManageTabs() {
    const location = useLocation();
    const isLogs = location.pathname === "/notiBypassSendLogs";

    return (
        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "14px", borderBottom: "1px solid #e2e8f0" }}>
            <TabLink to="/notiBypassTargets" active={!isLogs} icon={<ListChecks size={15} />} label="바이패스 대상 관리" />
            <TabLink to="/notiBypassSendLogs" active={isLogs} icon={<History size={15} />} label="전송 이력" />
        </div>
    );
}

function TabLink({ to, active, icon, label }) {
    return (
        <Link
            to={to}
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                minHeight: "38px",
                padding: "0 14px",
                border: "1px solid",
                borderColor: active ? "#2563eb" : "#e2e8f0",
                borderBottomColor: active ? "#fff" : "#e2e8f0",
                borderRadius: "6px 6px 0 0",
                backgroundColor: active ? "#fff" : "#f8fafc",
                color: active ? "#1d4ed8" : "#475569",
                fontSize: "13px",
                fontWeight: 800,
                textDecoration: "none",
                marginBottom: "-1px",
            }}
        >
            {icon}
            <span>{label}</span>
        </Link>
    );
}

export default OnuManageTabs;
